import VueRouter, { RouteConfig } from 'vue-router'

import ApprovalLeaveListPage from '@/views/approval-leave/ApprovalLeaveList.vue'
import AskForLeaveDetailsPage from '@/views/approval-leave/AskForLeaveDetails.vue'
import CreateLeaveRecordPage from '@/views/approval-leave/Create.vue'
import ApprovalLeaveSettingPage from '@/views/approval-leave/Setting.vue'
export const approvalLeaveListRoute: RouteConfig = {
  path: '/approval-leave-list',
  name: 'approval_leave_list',
  component: ApprovalLeaveListPage,
  meta: {
    title: '请假审批',
  },
  props: (route) => ({ category: route.query.category, title: route.query.title }),
}

export const askForLeaveDetailRoute: RouteConfig = {
  path: '/ask-for-leave-detail',
  name: 'ask_for_leave_detail',
  component: AskForLeaveDetailsPage,
  meta: {
    title: '请假信息',
  },
  props: (route) => ({ item: JSON.parse(route.query.item as string) }),
}

export const createLeaveRecordRoute: RouteConfig = {
  path: '/create-leave-record',
  name: 'create_leave_record',
  component: CreateLeaveRecordPage,
  meta: {
    title: '登记学生请假',
  },
}

export const approvalLeaveSettingRoute: RouteConfig = {
  path: '/create-leave-setting',
  name: 'create_leave_setting',
  component: ApprovalLeaveSettingPage,
  meta: {
    title: '请假设置',
  },
}

export default [approvalLeaveListRoute, askForLeaveDetailRoute, createLeaveRecordRoute, approvalLeaveSettingRoute]

export function navigateToApprovalLeaveList(router: VueRouter) {
  router.push({ name: approvalLeaveListRoute.name })
}

export function navigateToApprovalLeaveSetting(router: VueRouter) {
  router.push({ name: approvalLeaveSettingRoute.name })
}
